import Vue from 'vue'
Vue.directive('fontCut', {
  inserted(el, binding) {
    el.innerText = init(binding.value, el)
  },
  update(el, binding) {
    el.innerText = init(binding.value, el)
  }
})
function init(value, el) {
  const h = el.offsetHeight
  const w = el.offsetWidth
  const count = Math.floor(w / 12)
  if (h > 28 || el.innerText.length > 80) {
    const prevText = value?.substr?.(0, count * 2 - 3)
    return prevText?.length ? `${prevText}...` : prevText
  }
  return value
}
